import React, { useState } from 'react';
import Button from '../common/Button';
import Input from '../common/Input';
import BirthdayDropdowns from '../common/BirthdayDropdowns';
import { register } from '../../services/api';
import { useNavigate } from 'react-router-dom'
import SecureLS from 'secure-ls'
import { setUser } from '../../utils/secureStorage'

const ls = new SecureLS({ encodingType: 'aes' })

function RegistrationForm() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    date_of_birth: { day: '', month: '', year: '' }, // Initialize as an object
    password: '',
    password2: '' // Changed from confirmPassword to password2
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleBirthdayChange = (dateObj) => {
    setFormData(prevData => ({
      ...prevData,
      date_of_birth: dateObj
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      if (formData.password !== formData.password2) {
        throw new Error('Passwords do not match');
      }

      const { day, month, year } = formData.date_of_birth;
      const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

      const userData = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        date_of_birth: formattedDate,
        password: formData.password,
        password2: formData.password2  // Include password2 in the userData
      };

      const response = await register(userData);
      
      // Store user data matching the actual response structure
      setUser({
        id: response.user_id,          // Changed from id to user_id
        email: response.email,
        first_name: response.first_name,
        last_name: response.last_name,
        date_of_birth: response.date_of_birth,
        age: response.age
      })

      // Store auth token securely
      ls.set('authToken', response.token)
      localStorage.setItem('isLoggedIn', 'true')

      // Navigate to my-life page
      navigate('/my-life-v2')
    } catch (error) {
      console.error('Registration error:', error)
      setError(error.message || 'An error occurred during registration')
    } finally {
      setIsLoading(false)
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {error && <div className="text-red-500 text-center">{error}</div>}
      <div>
        <div className="flex space-x-4">
          <div className="w-1/2">
            <label className="block text-base font-bold text-gray-700 mb-2" htmlFor="first_name">
              First Name
            </label>
            <Input
              type="text"
              placeholder="First Name"
              name="first_name"
              id="first_name"
              value={formData.first_name}
              onChange={handleChange}
              className="w-full px-4 py-4 text-lg border-2 border-gray-300 rounded-lg focus:border-[#556B2F] focus:outline-none"
              required
            />
          </div>
          <div className="w-1/2">
            <label className="block text-base font-bold text-gray-700 mb-2" htmlFor="last_name">
              Last Name
            </label>
            <Input
              type="text"
              placeholder="Last Name"
              name="last_name"
              id="last_name"
              value={formData.last_name}
              onChange={handleChange}
              className="w-full px-4 py-4 text-lg border-2 border-gray-300 rounded-lg focus:border-[#556B2F] focus:outline-none"
              required
            />
          </div>
        </div>
      </div>
      <div>
        <label className="block text-base font-bold text-gray-700 mb-2" htmlFor="email">
          Email Address
        </label>
        <Input
          type="email"
          placeholder="Enter your email"
          name="email"
          id="email"
          value={formData.email}
          onChange={handleChange}
          className="w-full px-4 py-4 text-lg border-2 border-gray-300 rounded-lg focus:border-[#556B2F] focus:outline-none"
          required
        />
      </div>
      <div>
        <label className="block text-base font-bold text-gray-700 mb-2" htmlFor="date_of_birth">
          Date of Birth
        </label>
        <BirthdayDropdowns
          onChange={handleBirthdayChange}
          value={formData.date_of_birth}
        />
      </div>
      <div>
        <label className="block text-base font-bold text-gray-700 mb-2" htmlFor="password">
          Create Password
        </label>
        <Input
          type="password"
          placeholder="Create a secure password"
          name="password"
          id="password"
          value={formData.password}
          onChange={handleChange}
          className="w-full px-4 py-4 text-lg border-2 border-gray-300 rounded-lg focus:border-[#556B2F] focus:outline-none"
          required
        />
      </div>
      <div>
        <label className="block text-base font-bold text-gray-700 mb-2" htmlFor="password2">
          Confirm Password
        </label>
        <Input
          type="password"
          placeholder="Confirm your password"
          name="password2"
          id="password2"
          value={formData.password2}
          onChange={handleChange}
          className="w-full px-4 py-4 text-lg border-2 border-gray-300 rounded-lg focus:border-[#556B2F] focus:outline-none"
          required
        />
      </div>
      <div>
        <Button 
          type="submit" 
          className="w-full bg-[#556B2F] hover:bg-[#4A5D23] text-white border-none py-4 px-4 text-lg font-bold rounded-lg cursor-pointer transition-colors"
          disabled={isLoading}
        >
          {isLoading ? 'Creating Account...' : 'Create Account'}
        </Button>
      </div>
    </form>
  );
}

export default RegistrationForm;